import { render, staticRenderFns } from "./classifiedRecommendation.vue?vue&type=template&id=9e4b4688&"
import script from "./classifiedRecommendation.vue?vue&type=script&lang=js&"
export * from "./classifiedRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./classifiedRecommendation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports